// extracted by mini-css-extract-plugin
module.exports = {"Profession":"index-module_Profession_1-1yn"};